import React, { useContext } from 'react';
import "./PromotionCard.css";
// import NintendoStore from "./imaged/playstation-store.jpg";
import { useTranslation } from 'react-i18next';

// import img from "./image 1 copy.jpg";

function PromotionCard(props) {

  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation


  return (
    <div className="promo">
      <div className="card-index"></div>
      <img
        className="promo-img"
        // src={props.element.background_image}
        src={require(`../../assets/${props.element.img}`)}

        alt="this is image"
      />

      <div className="promo-card">
        <div>
          <div className="promo-logo">
            <img

              src={require("../../assets/RN69.png")}
              alt="RN69"
              width={60}
            />
          </div>
          <div className="card-index-1"></div>

          <div className="text-center">
            <h1 class="text-stoke-fill-gradient">{t(props.element.text).split('\n').map((item, index) => (
              <span key={index}>
                {item}
                {index < t(props.element.text).split('\n').length - 1 && <br />}
              </span>
            ))}</h1>
          </div>
        </div>
      </div>
      {/* <button
        className="btn-promo btn bg-white  text-capitalize"
        onClick={() => { }} //1 2 3 4 5
      >
        GET NOW
      </button> */}
    </div>
  );
}

export default PromotionCard;
